import React from 'react';

import Links from '../../../../links/Links.jsx';
import Contacts from '../../contacts/Contacts.jsx';
import BackOfficeAccess from '../../others/BackOfficeAccess.jsx';
import Version from '../../others/Version';
import Roadmap from '../../roadmap/Roadmap';

const MainSidebar = () => (
  <div className="sidebar-content-p">
    <Roadmap/>
    <Links/>
    <Contacts/>
    <BackOfficeAccess/>
    <Version/>
  </div>
);

export default MainSidebar;



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/sidebar/MainSidebar.jsx